















































































import { DocumentConsents } from "@/api/open-api";
import { QTable } from "quasar";
import Vue from "vue";
import moment from "moment";
import DailyCustomerConsentAggregateConsentsVue from "./DailyCustomerConsentAggregateConsents.vue";

interface Data {
  expanded: string[];
  table: QTable;
}

export default Vue.extend({
  name: "c-daily-customer-consent-aggregate-document-consents",
  components: {
    "c-daily-customer-consent-aggregate-consents": DailyCustomerConsentAggregateConsentsVue
  },

  props: {
    documentConsents: {
      type: Array as () => DocumentConsents[]
    }
  },

  data(): Data {
    return {
      expanded: [] as string[],
      table: {
        columns: [
          {
            name: "documentImage",
            label: "",
            field: ((row: DocumentConsents) => {
              switch (row.documentSlug) {
                case "email":
                  return "/img/icons/documents/email_blue.png";
                case "privacy":
                  return "/img/icons/documents/privacy_blue.png";
                case "7A":
                  return "/img/icons/documents/7a_blue.png";
                case "7B":
                  return "/img/icons/documents/7b_blue.png";
              }

              return "/img/icons/documents/doc_empty_blue.png";
            }) as Function
          },
          {
            name: "documentName",
            label: "",
            field: ((row: DocumentConsents) => row.documentSlug) as Function
          },
          {
            name: "lastUpdatedAt",
            label: "",
            field: ((row: DocumentConsents) => {
              return moment(row.lastConsentUpdate).format("LT");
            }) as Function
          }
        ]
      } as QTable
    };
  },

  methods: {
    getRowKey(row: DocumentConsents) {
      return JSON.stringify(row);
    },

    expandAll() {
      this.expanded =
        this.documentConsents.map((item: DocumentConsents) =>
          this.getRowKey(item)
        ) ?? [];
    }
  }
});
